import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { connect } from 'react-redux';
import styles from './styles.module.scss';

const { Option } = Select;

class XeroAccountCell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
    };
  }

  toggleEdit = () => {
    const { editing } = this.state;
    this.setState({ editing: !editing }, () => {
      const { editing: isEdit } = this.state;
      if (isEdit) {
        this.input.focus();
      }
    });
  };

  onAccountSelected = (accountCode) => {
    this.toggleEdit();
    const { onAccountSelected, xeroAccounts } = this.props;
    onAccountSelected(xeroAccounts.find((account) => account.account_code === accountCode));
  };

  formatXeroAccountLabel = (xeroAccount) => {
    let label;
    if (xeroAccount.account_name) {
      label = `${xeroAccount.account_code} - ${xeroAccount.account_name}`;
    } else {
      label = `${xeroAccount.account_code}`;
    }
    return label;
  };

  render() {
    const { value, xeroAccounts } = this.props;
    const { editing } = this.state;
    const accountCode = (value && value.account_code) || null;

    let text;
    if (value) {
      text = <span className={styles.Value}>{this.formatXeroAccountLabel(value)}</span>;
    } else {
      text = <span className={styles.NoSelected}>Not specified</span>;
    }

    if (editing) {
      text = (
        <Select
          placeholder="Not specified"
          showArrow={false}
          ref={(node) => {
            this.input = node;
          }}
          defaultValue={accountCode || undefined}
          dropdownMatchSelectWidth={false}
          defaultOpen
          onChange={this.onAccountSelected}
          onBlur={this.toggleEdit}
        >
          {xeroAccounts && xeroAccounts.map((xeroAccount) => (
            <Option
              key={xeroAccount.account_code}
              value={xeroAccount.account_code}
            >
              {this.formatXeroAccountLabel(xeroAccount)}
            </Option>
          ))}
        </Select>
      );
    }

    return <div className={styles.XeroAccountCell} onClick={this.toggleEdit}>{text}</div>;
  }
}

XeroAccountCell.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    account_code: PropTypes.string,
  }),
  onAccountSelected: PropTypes.func.isRequired,
  xeroAccounts: PropTypes.arrayOf(PropTypes.shape({})),
};

XeroAccountCell.defaultProps = {
  value: undefined,
  xeroAccounts: [],
};

const mapStateToProps = ({ xeroService }) => ({
  xeroAccounts: xeroService.xeroAccounts,
});

export default connect(mapStateToProps)(XeroAccountCell);
